export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-4xl mx-auto text-center">
        <p className="font-heading text-xl md:text-2xl text-foreground-400 italic mb-10">
          ( Trusted by Shoppers Worldwide )
        </p>

        <div className="relative bg-background-50 rounded-3xl p-8 md:p-12">
          <div className="absolute top-6 left-6 md:top-8 md:left-8">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-foreground-900 text-background-50 text-xs font-semibold rounded-full">
              <i className="ri-star-fill text-accent-400 text-xs w-3 h-3 flex items-center justify-center"></i>
              4.9
            </span>
          </div>

          <div className="mt-8 md:mt-4 max-w-2xl mx-auto">
            <div className="text-left">
              <span className="text-4xl md:text-5xl font-heading text-foreground-300 leading-none">&ldquo;</span>
              <p className="font-heading text-lg md:text-xl text-foreground-700 leading-relaxed italic -mt-4">
                The GTBuy spreadsheet system completely changed how I organize my shopping. Instead of juggling dozens of browser tabs and losing track of products I liked, I now have everything structured in one clean spreadsheet. The category navigation on this site makes it even easier to jump straight to what I need. This is hands down the most efficient way to shop online in 2026.
              </p>
              <span className="text-4xl md:text-5xl font-heading text-foreground-300 leading-none float-right">&rdquo;</span>
            </div>

            <div className="flex items-center gap-3 mt-10 pt-6 border-t border-background-200/70">
              <div className="w-11 h-11 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-user-line text-primary-600 text-lg w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div className="text-left">
                <p className="text-sm font-semibold text-foreground-900">Sarah Mitchell</p>
                <p className="text-xs text-foreground-500">Verified Spreadsheet Shopper</p>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 mt-8">
            <button className="w-10 h-10 rounded-lg border border-background-300 flex items-center justify-center hover:bg-background-100 transition-colors">
              <i className="ri-arrow-left-line text-foreground-600 text-sm w-4 h-4 flex items-center justify-center"></i>
            </button>
            <button className="w-10 h-10 rounded-lg bg-foreground-900 flex items-center justify-center hover:bg-foreground-800 transition-colors">
              <i className="ri-arrow-right-line text-background-50 text-sm w-4 h-4 flex items-center justify-center"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}